import { render, staticRenderFns } from "./AffiliationCustom.vue?vue&type=template&id=ef31a90e&scoped=true&"
import script from "./AffiliationCustom.vue?vue&type=script&lang=js&"
export * from "./AffiliationCustom.vue?vue&type=script&lang=js&"
import style0 from "./AffiliationCustom.vue?vue&type=style&index=0&id=ef31a90e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef31a90e",
  null
  
)

export default component.exports